import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import * as websocketTypes from 'modules/websockets/actionTypes';
import { FETCH_ENTITY_SUCCESS } from 'modules/entity/actionTypes';
import { readMessagesSuccess } from 'modules/chat/actions';

/**
 * @typedef {string} ReceivedMessageAtState
 */

/** @type {ReceivedMessageAtState} */
const initialState = null;

const set = () => {
  const now = new Date();
  return now.toISOString();
};

const reset = () => null;

const setFromEntity = (_, { payload: entity }) =>
  (entity.readMessagesUrl ? set() : reset());

export default createReducer(initialState, (builder) => {
  builder
    .addCase(websocketTypes.MESSAGE_RECEIVED_FROM_SOCKET, set)
    .addCase(FETCH_ENTITY_SUCCESS, setFromEntity)
    .addMatcher(isAnyOf(readMessagesSuccess.match), reset);
});
